import { GET_USER, GET_REFERAL_USER_BY_ID } from "../constants/index";

export const Referaluser = (state = { userlist: [], Refaraluserbyid: {} }, action) => {
  switch (action.type) {
    case GET_USER:
      return { ...state, userlist: action.userlist };
    case GET_REFERAL_USER_BY_ID:
      return { ...state, Refaraluserbyid: action.Refaraluserbyid };
    default:
      return state;
  }
};
